import React from 'react';
import { Breadcrumb, Select, Popover, Button } from 'antd';
import { Container, Row, Col } from 'reactstrap';
import CreateNewCategory from '../CompanyCategory/CreateNewCategory';

export class CreateCompanyCategory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user: this.props.token,
            catSaved: false,
            catCounter: [{ id:1 }]
        };

        this.addCat = this.addCat.bind(this);
        this.callbackCatSaved = this.callbackCatSaved.bind(this);

    }

    addCat() {
        let counter = this.state.catCounter
        let newId = counter.length +1       
        let newCat = { id: newId  }
        counter.push(newCat)
        this.setState({ catSaved: false, catCounter:counter })
    }

    callbackCatSaved = (childData) => {
        this.setState({ catSaved: childData })
    }

    goBack() {
        return window.open("/category/index", '_self');
    }
        
    render() {

        let addNewCat = this.state.catSaved ? <Button className="buttonAddNewCat" style={{ position: 'relative', top: '15px' }} onClick={this.addCat}>Add new Category</Button> : <Popover content="You need to save the prior Category in order to add a new one"><Button className="buttonAddNewCat" disabled style={{ position: 'relative', top: '15px' }} >Add new Category</Button></Popover> 

        return (
            <Container fluid={true}>
                <Row>
                    <Col sm="12" style={{ display: 'inline-flex' }}>
                        <Button className="backButt" icon="caret-left" onClick={this.goBack}></Button>
                        <Breadcrumb className="bread">
                            <Breadcrumb.Item>Create Category</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>

                    <Row style={{ width: '100%' }}>
                        <Col style={{ minHeight: '50vh' }} sm='12'>
                            <div className="wizardFields wizardContacts" style={{ minHeight: '50vh' }}>
                                <div className="wizardBackground createCat" style={{ height: 'inherit' }}>
                                    <div>
                                        {this.state.catCounter.map(i =>
                                            <CreateNewCategory parentCallbackCatSaved={this.callbackCatSaved} user={this.state.user} key={i.id} />
                                        )}
                                    </div>
                                    {addNewCat}
                                </div>                                
                            </div>
                        </Col>
                    </Row>
                </Row>
            </Container>   
        )
    }
}


// WEBPACK FOOTER //
// ./src/CompanyCategory/CreateCompanyCategory.js